
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recreational-activities",
      function () {
        return require("private-next-pages/recreational-activities/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recreational-activities"])
      });
    }
  